import {createFeatureSelector, createSelector} from '@ngrx/store';
import {ModuleState, PageState} from './meine-aufgaben.reducer';
import {IncidentDetail,  IncidentKopf,  Rolle} from '../../../clients/incidents';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';


export const getModuleState = createFeatureSelector<ModuleState>('MeineAufgabenPage');

export const getPageState = createSelector(getModuleState, (state: ModuleState) => state.page);


export const getSelectedVeranstaltungsIds = createSelector(getPageState, (state: PageState) => {
    return state.localData ? state.localData.selectedVeranstaltungsIds : [];
});

export const getAbgeschlosseneAnzeigen = createSelector(getPageState, (state: PageState) => state.abgeschlosseneAnzeigen);

export const getEingang = createSelector(getPageState, getAbgeschlosseneAnzeigen, (state: PageState, abgeschlosseneAnzeigen: boolean): Array<ListInputItem> => {
    if (state.eingang === null) {
        return [];
    }

    if (abgeschlosseneAnzeigen) {
        return state.eingang.items.filter(x => x.ist_meins || x.ist_meine_delegation).map((item: IncidentKopf) => <ListInputItem>{
            groupId: 'Aktuelle Veranstaltungen',
            groupTitle: 'Aktuelle Veranstaltungen',
            itemId: item.incident_id,
            itemTitle: item.titel,
            item: item
        });
    } else {
        return state.eingang.items.filter(x => (x.ist_meins || x.ist_meine_delegation) && !x.ist_abgeschlossen).map((item: IncidentKopf) => <ListInputItem>{
            groupId: 'Aktuelle Veranstaltungen',
            groupTitle: 'Aktuelle Veranstaltungen',
            itemId: item.incident_id,
            itemTitle: item.titel,
            item: item
        });
    }
});
export const getEingangAbgeschlossen = createSelector(getPageState, getAbgeschlosseneAnzeigen, (state: PageState, abgeschlosseneAnzeigen: boolean): Array<ListInputItem> => {
    if (state.eingang === null) {
        return [];
    }

    if (abgeschlosseneAnzeigen) {
        return state.eingang.items.filter(x => !(x.ist_meins || x.ist_meine_delegation)).map((item: IncidentKopf) => <ListInputItem>{
            groupId: 'Aktuelle Veranstaltungen',
            groupTitle: 'Aktuelle Veranstaltungen',
            itemId: item.incident_id,
            itemTitle: item.titel,
            item: item
        });
    } else {
        return state.eingang.items.filter(x => !(x.ist_meins || x.ist_meine_delegation) && !x.ist_abgeschlossen).map((item: IncidentKopf) => <ListInputItem>{
            groupId: 'Aktuelle Veranstaltungen',
            groupTitle: 'Aktuelle Veranstaltungen',
            itemId: item.incident_id,
            itemTitle: item.titel,
            item: item
        });
    }
});
export const getEingangLaden = createSelector(getPageState, (state: PageState) => state.eingangLaden);

export const getSelectedIncident = createSelector(getPageState, (state: PageState) => state.selectedIncident);

export const getIncidentDetail = createSelector(getPageState, (state: PageState) => state.incidentDetail);
export const getIncidentDetailLaden = createSelector(getPageState, (state: PageState) => state.incidentDetailLaden);

export const getDelegationRollen = createSelector(getIncidentDetail, (detail: IncidentDetail): Array<Rolle> => {
    const retListe: Array<Rolle> = [];

    if (detail !== undefined && detail !== null && detail.ist_verantwortlichkeit_abteilung) {
        detail.abteilungen.forEach(abteilung => {
            if (abteilung.abteilung.funktionsbereich_id === detail.verantwortlichkeit_funktionsbereich_id) {
                retListe.push(...abteilung.rollen);
            }
        });
    }

    if (detail !== undefined && detail !== null && detail.ist_verantwortlichkeit_zentrale) {
        retListe.push(...detail.rollen_zentrale);
    }

    return retListe;
});

export const getSelectedMeldung = createSelector(getPageState, (state: PageState) => state.selectedMeldung);

export const getLetzteMeldungAnzeigen = createSelector(getPageState, (state: PageState) => state.letzteMeldungenAnzeigen);

export const getLetzteSystemMeldungAnzeigen = createSelector(getPageState, (state: PageState) => state.letzteSystemMeldungenAnzeigen);




